export default __webpack_public_path__ + "static/media/mastercard-226450.52c64134.png";